<template>
  <esg-base-chart>
    <apex-chart ref="chart"
                type="donut"
                height="300"
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    year: {
      type: Number
    },
    product: {
      type: Object,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        labels: [],
        chart: {
          type: 'donut',
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  formatter: val => this.formatNumber(val, 2) + ' tCO2e'
                },
                total: {
                  show: true,
                  color: 'black',
                  label: '폐기 배출량',
                  formatter: chart => {
                    let total = chart.config.series.reduce((a, b) => a + b, 0);
                    return this.formatNumber(total, 2) + ' tCO2'
                  }
                },
              },
            },
          },
        },
        tooltip: {
          y: {
            show: true,
            formatter: val => this.formatNumber(val, 2) + ' tCO2e'
          },
        },
        legend: {
          position: 'bottom',
        },
        dataLabels: {
          enabled: true, //=> 데이터 series값 출력
        },
      },
    }
  },
  watch: {
    product: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchData()
      }
    },
    year: {
      immediate: true,
      handler() {
        this.fetchData()
      }
    }
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      if (!this.product || !this.product.productFamilyCode || !this.product.productCode || !this.product.name) return
      if (!this.year) return

      try {
        // Chart meta data
        let chartMeta = [{
          years: [this.year],
          productFamilies: [this.product.productFamilyCode],
          products: [this.product.productCode],
          groupKeys: ['activity_subcategory']
        }]

        // Construct form data for HTTP request
        let formData = new FormData()
        formData.append('path', 'esg/lca/disposal_detail/main')
        formData.append('json', JSON.stringify(chartMeta))

        // Request data for the chart
        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', formData, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, return
        if (!response.data.data) {
          return
        }

        // Parse JSON data
        let respData = JSON.parse(response.data.data).pop()

        // Filter out the data in the past
        let chartData = respData.data.filter(row => row.year === this.currYear)

        // Extract series and labels
        let series = []
        let labels = []
        chartData.forEach(row => {
          series.push(row.values)
          labels.push(row.activity_subcategory)
        })

        this.series = series
        this.chartOptions.labels = labels
      } catch (error) {
        await this.showError(error)
      } finally {
        this.refreshChart()
      }
    },
  }
}
</script>
